import { render, staticRenderFns } from "./AboutUs_Component..vue?vue&type=template&id=65038a54&scoped=true&"
import script from "./AboutUs_Component..vue?vue&type=script&lang=js&"
export * from "./AboutUs_Component..vue?vue&type=script&lang=js&"
import style0 from "./AboutUs_Component..vue?vue&type=style&index=0&id=65038a54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65038a54",
  null
  
)

export default component.exports